import {loadData, SESSION_KEY} from '../storage/local-storage';

import {LOGIN_REQUEST, LOGIN_SUCCESS, LOGIN_FAILURE, LOGOUT_REQUEST, LOGOUT_SUCCESS} from '../actions';

const session = loadData(SESSION_KEY) || {};
export const AUTH_INITIAL_STATE = {
    isFetching: false,
    isAuthenticated: !!(session && session.access_token),
    session
};

const authReducers = {
    [LOGIN_REQUEST]: (state, {creds}) => {
        return Object.assign({}, state, {
            isFetching: true,
            isAuthenticated: false,
            creds,
            session: {},
            error: null
        });
    },
    [LOGIN_SUCCESS]: (state, {session}) => {
        return Object.assign({}, state, {
            creds: {},
            isFetching: false,
            isAuthenticated: true,
            session,
            error: null
        });
    },
    [LOGIN_FAILURE]: (state, {error}) => {
        return Object.assign({}, state, {
            isFetching: false,
            isAuthenticated: false,
            error
        });
    },
    [LOGOUT_REQUEST]: (state) => {
        return Object.assign({}, state, {
            isFetching: true
        });
    },
    [LOGOUT_SUCCESS]: (state) => {
        return Object.assign({}, state, {
            isFetching: false,
            isAuthenticated: false,
            session: {}
        });
    },
};

export default function auth(state = AUTH_INITIAL_STATE, action) {
    let reducer = authReducers[action.type] || (state => state);
    return reducer(state, action);
}

export const getAuth = (state) => {
    return Object.assign({}, state);
};


// WEBPACK FOOTER //
// ./resources/assets/js/reducers/auth.js